module.exports = __webpack_public_path__ + "static/media/YM52_3.dd656dd1.jpg";